import { tickerItems } from '@/mocks/homeData';

export default function TopTicker() {
  const loopItems = [...tickerItems, ...tickerItems];
  return (
    <div className="w-full border-b border-accent-200/70 bg-accent-50">
      <div className="flex items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5">
          <span className="h-1.5 w-1.5 animate-live-dot rounded-full bg-accent-500"></span>
          <span className="font-label text-xs font-medium text-accent-700">实时</span>
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center">
            {loopItems.map((item, index) => (
              <span key={`${item}-${index}`} className="flex items-center">
                <span className="whitespace-nowrap px-4 font-label text-xs text-foreground-700">
                  {item}
                </span>
                <span className="h-1 w-1 rounded-full bg-accent-300"></span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}